import Vue from 'vue'
import VueI18n from 'vue-i18n'
import * as Settings from '@/infra/settings'
import * as Locales from '@/infra/locales'
import es from './messages/es'
import fr from './messages/fr'
import it from './messages/it'
import en from './messages/en'
import de from './messages/de'
import pl from './messages/pl'

const numberFormats = {
  'es-ES': {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  }
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: Settings.getLocale(),
  fallbackLocale: Locales.types.EN,
  silentTranslationWarn: true,
  messages: {
    es,
    fr,
    it,
    en,
    de,
    pl
  },
  numberFormats
})

export default i18n
